export class AreaRect {
	public aGroup: any[];
	public x: number;
	public y: number;
	public width: number;
	public height: number;
}